module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJElEQVQokYXSsUucQRAF8N+nH6gJiKC1bbC2srMRK4MgdqJWFkIQrRQjVmkE01laxEbvXxALSwtTREQtUkgqQRMQLIyedxY3C8txngPDsrPvzby3u8Xobm0eG+hDzdtRRN5ivRjdrf3FbxyjbEOEKibQUwZ4B3vvkFLcY60MeR+j2ItBdKCeSaziDx7QjeckLYFmNfwWTcQXrOJHqpXZIQ2fT+hsMfEkxzZfxjkuWviqZ40IL7nUGVwG+TzyEmeYzLHNE29wGnLSm3biP+5yYCKmyUeR7aIjJzzEuoBv6M+An7CNz7F/TBNfMIDNyAIjmNP4hhUMYRHL+IB6In6NJl9whQONp+kKNcOYxvfw+6/EEsaxj8OQM4atIK3gGr/wE1OovAKZqUfmDYzbgwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/invoice_active.png
// module id = 6YSf
// module chunks = 3